import { getAttrValue, getLocalizedAttrValue, getNestedProperty, getFrontImage } from '@grandvisionhq/utils';

const parseProductData = (product, activeVariant, locale)=>{
    const image = getProductImageUrl(activeVariant);
    const name = product.name.en || getAttrValue(activeVariant, 'brandModelCode');
    const description = getLocalizedAttrValue(activeVariant, 'description', locale);
    const brand = getAttrValue(activeVariant, 'brand');
    const firstCategory = getNestedProperty(product, 'categories')[0] || '';
    const category = getNestedProperty(firstCategory, `obj.name.en`, '');
    const sku = activeVariant.sku || '';
    return {
        name,
        image,
        description,
        brand,
        category,
        sku
    };
};
function getProductImageUrl(variant) {
    var ref;
    return getFrontImage((ref = variant.media) === null || ref === void 0 ? void 0 : ref.images).url;
}

export { parseProductData };
//# sourceMappingURL=parse-product-data.js.map
